/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, object, string, shape,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

import { deepObjectExtend } from '../../../utils/object';
import { main as mainStyle } from '../../../style/main';
import SubscriptionFrequencyForm from './SubscriptionFrequencyForm';

const styles = ({ typography, palette }) => deepObjectExtend(mainStyle(typography, palette), {
    recipientDialogRoot: {
        width: '100%',
        boxSizing: 'border-box',
        alignItems: 'normal',
        height: '100%',
    },
    recipientDialogPaper: {
        boxSizing: 'border-box',
        borderRadius: '0',
        margin: '0 19.5px',
        boxShadow: '0px 0px 20px 6px rgba(0,0,0,0.5)',
        height: '673px',
        width: '100%',
        maxWidth: '454px',
        overflowY: 'auto',
        '@media screen and (min-width: 768px)': {
            minWidth: '55%',
        },
    },
});

function SubsriptionFrequencyModalDialog({
    openModal, classes, closeModal, subscription, updateSubscriptionList, enableEditButton,
}) {
    return (
        <Dialog
            data-testid="subscription-recipient-form-modal"
            open={openModal}
            classes={{
                root: classes.recipientDialogRoot,
                paper: classes.recipientDialogPaper,
            }}
        >
            <SubscriptionFrequencyForm
                openModal={openModal}
                closeModal={closeModal}
                subscription={subscription}
                enableEditButton={enableEditButton}
                updateSubscriptionList={updateSubscriptionList}
            />
        </Dialog>
    );
}

SubsriptionFrequencyModalDialog.propTypes = {
    classes: object.isRequired,
    subscription: shape({
        productId: string,
    }),
    closeModal: func,
    openModal: func,
    updateSubscriptionList: func.isRequired,
    enableEditButton: func.isRequired,
};
SubsriptionFrequencyModalDialog.defaultProps = {
    subscription: {},
    openModal: () => {},
    closeModal: () => {},
};
export default withStyles(styles, { withTheme: true })(SubsriptionFrequencyModalDialog);
